export const FEATURE_GATE_STUDIO_IA_PHASE_6 = 'studio_ia_phase_6';
